export default class WorkspaceProperties {
  name?: string;
}
